export enum TemplateAccess {
    Global,
    Customer
}

export enum ImplementCategory {
    GET = 1,
    DumpBody = 2
}

export enum ComponentTypeCategory {
    GET = 8,
    DumpBody = 11
}

export class NewImplementTemplate {
    public TemplateId: number;
    public TemplateName: string;
    public TemplateAccess: TemplateAccess;
    public CustomerId: number;
    public ImplementCategory: ImplementCategory;
    public EquipmentModels: number[];
    public ComponentTypes: ImplementComponentType[];
}

export class ImplementComponentType {
    public Id: number;
    public Name: string;
}

export class ImplementTemplate {
    public TemplateId: number;
    public TemplateName: string;
    public CustomerName: string;
    public CustomersUsing: number;
    public ImplementCategory: ImplementCategory;
    public ShowTemplate: boolean;
}